var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', [_vm.$vuetify.breakpoint.mdAndUp ? _c('NavBar', {
    staticClass: "navbar"
  }) : _vm._e(), _vm.$vuetify.breakpoint.smAndDown ? _c('NavBarMobile', {
    staticClass: "navbar_mobile"
  }) : _vm._e(), _c('div', [_c('TestnetAlert'), _c('div', {
    staticClass: "side_container"
  }, [_c('v-content', {
    staticClass: "content"
  }, [_c('router-view', {
    staticClass: "router_view"
  })], 1)], 1)], 1), _c('Footer', {
    staticClass: "footer"
  }), _c('Notifications')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }